module.exports = __webpack_public_path__ + "static/media/CAR-1.c981c764.jpg";